var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import '../../../shared/css/Container.css';
import { useThemeable } from '../ProviderStyleAccess';
import { checkChildren } from './checkChildren';
import { useViewportSize, ViewportSizeProvider } from '../ProviderResponsive';
var Container = function (_a) {
    var interactive = _a.interactive, children = _a.children, _b = _a.width, width = _b === void 0 ? 'fill' : _b, _c = _a.height, height = _c === void 0 ? 'hug' : _c, _d = _a.variant, variant = _d === void 0 ? 'default' : _d, _e = _a.className, className = _e === void 0 ? '' : _e, style = _a.style;
    var _f = useState(false), isInteractive = _f[0], setIsInteractive = _f[1];
    var spacingMode = useViewportSize().spacingMode;
    var space = useThemeable().space;
    useEffect(function () {
        if (interactive === undefined) {
            setIsInteractive(checkChildren(children) || false);
        }
        else {
            setIsInteractive(interactive);
        }
    }, []);
    var containerStyles = {
        margin: spacingMode === 'normal'
            ? "".concat(space.vUnify + space.vExtra, "px ").concat(space.hUnify + space.hExtra, "px")
            : "".concat(space.vUnify, "px ").concat(space.hUnify, "px"),
    };
    var containerClasses = [
        'container',
        isInteractive && 'interactive middle',
        'v-stack',
        "width-".concat(width),
        "height-".concat(height),
        className,
        'ungroup',
        variant && "container-".concat(variant)
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("div", { className: containerClasses, style: __assign(__assign({}, containerStyles), style), children: _jsx(ViewportSizeProvider, { setSpacingMode: 'normal', children: children }) }));
};
export { Container };
